export const enum SpatialAudioAttachmentType {
    Position = 1,
    Rotation = 2,
    PositionAndRotation = 3,
}
